import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class RedirectGuard implements CanActivate {
  constructor() { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!state.url.includes('login')) {
      window.location.href = environment.tempUrl;
      return;
    }

    return true;

  }
}
